"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { ApplicationConstants } from 'Constants/ApplicationConstants';
import { Fields, System } from 'Constants/objects';
import { Map } from 'immutable';
import { user } from "Models/UserModel";
import { UserSettings } from "D5Utils/UserSettings";
import { getSystemParam } from "D5Utils/functions";
var defStore = Map({
  route: '',
  initialized: false,
  routerLoaded: false,
  langLoaded: false,
  theme: System.THEME.LIGHT,
  direction: System.DIRECTION.LTR,
  drawerWidth: 240,
  drawerAnchor: System.DIRECTION.LEFT,
  drawerOpen: true
});

var _store = defStore.toObject();

var CHANGE_EVENT = 'change';

var ApplicationStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(ApplicationStoreClass, _StoreClass);

  function ApplicationStoreClass() {
    _classCallCheck(this, ApplicationStoreClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(ApplicationStoreClass).apply(this, arguments));
  }

  _createClass(ApplicationStoreClass, [{
    key: "setInitialize",
    value: function setInitialize() {
      _store.initialized = _store.routerLoaded && _store.langLoaded;

      if (_store.initialized) {
        _store = Map(_store).merge(Map(this.loadSettings())).toObject();
        ApplicationStore.emit(CHANGE_EVENT);
      }
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {
      var lsSettings = {},
          theme = localStorage.getItem('theme'),
          direction = localStorage.getItem("".concat(user.getUserID(), "-theme-direction")),
          width = localStorage.getItem("".concat(user.getUserID(), "-theme-drawerWidth")),
          anch = localStorage.getItem("".concat(user.getUserID(), "-theme-drawerAnchor"));
      if (theme) lsSettings.theme = theme;
      if (direction) lsSettings.direction = direction;
      if (width) lsSettings.drawerWidth = Number(width);
      if (anch) lsSettings.drawerAnchor = anch;
      var regSett = UserSettings.getRegionalSettings()[Fields.RegionalLocale];
      var lang = regSett && "".concat(regSett, "-").match(/(\w+)-/)[1];
      DevExpress.localization.locale(UserSettings.getApplicationLang());

      if (lang) {
        $.when($.getJSON("https://unpkg.com/cldr-dates-full/main/".concat(lang, "/ca-gregorian.json")), $.getJSON("https://unpkg.com/cldr-numbers-full/main/".concat(lang, "/numbers.json")), $.getJSON("https://unpkg.com/cldr-numbers-full/main/".concat(lang, "/currencies.json")), $.getJSON("libs/cldr-core/supplemental/likelySubtags.json"), $.getJSON("libs/cldr-core/supplemental/timeData.json"), $.getJSON("libs/cldr-core/supplemental/weekData.json"), $.getJSON("libs/cldr-core/supplemental/currencyData.json"), $.getJSON("libs/cldr-core/supplemental/numberingSystems.json")).then(function () {
          // Normalizes $.getJSON results getting only the JSON without the request statuses
          return [].slice.apply(arguments, [0]).map(function (result) {
            return result[0];
          });
        }).then(Globalize.load).then(function () {
          Globalize.locale(lang);
        });
      }

      return lsSettings;
    }
  }, {
    key: "strip",
    value: function strip(html) {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    }
  }, {
    key: "setFavicon",
    value: function setFavicon() {
      var link = document.createElement('link');
      var faviconPath = getSystemParam('MainForm', 'Logo');
      link.setAttribute('href', faviconPath);
      link.setAttribute('type', 'image/x-icon');
      link.setAttribute('rel', 'icon');
      document.head.appendChild(link);
      link.setAttribute('rel', 'shortcut icon');
      document.head.appendChild(link);
    }
  }, {
    key: "setDocumentTitle",
    value: function setDocumentTitle() {
      document.title = getSystemParam('MainForm', 'Title');
    }
  }, {
    key: "register",
    value: function register() {
      var _this = this;

      AppDispatcher.register(function (action) {
        switch (action.actionType) {
          case ApplicationConstants.NAVIGATE:
            _store.route = action.route;
            ApplicationStore.emit(CHANGE_EVENT);
            break;

          case ApplicationConstants.ROUTER_LOADED:
            _store.routerLoaded = true;
            ApplicationStore.setInitialize();
            break;

          case ApplicationConstants.LANG_LOADED:
            _store.langLoaded = true;
            ApplicationStore.setInitialize();
            break;

          case ApplicationConstants.CHANGE_THEME:
            _store.theme = action.theme;
            localStorage.setItem('theme', _store.theme);
            ApplicationStore.emit(CHANGE_EVENT);
            break;

          case ApplicationConstants.CHANGE_THEME_DIRECTION:
            _store.direction = _store.direction === System.DIRECTION.RTL ? System.DIRECTION.LTR : System.DIRECTION.RTL;
            localStorage.setItem("".concat(user.getUserID(), "-theme-direction"), _store.direction);
            ApplicationStore.emit(CHANGE_EVENT);
            break;

          case ApplicationConstants.CHANGE_DOCUMENT_TITLE:
            document.title = getSystemParam('MainForm', 'DocumentTitlePrefix') + _this.strip(action.value);
            break;

          case ApplicationConstants.SET_DOCUMENT_TITLE:
            ApplicationStore.setDocumentTitle();
            break;

          case ApplicationConstants.SIDE_DRAWER_UPDATE_WIDTH:
            _store.drawerWidth = action.width;
            ApplicationStore.emit(CHANGE_EVENT);
            break;

          case ApplicationConstants.SIDE_DRAWER_CHANGE_ANCHOR:
            _store.drawerAnchor = action.anchor;
            localStorage.setItem("".concat(user.getUserID(), "-theme-drawerAnchor"), _store.drawerAnchor);
            ApplicationStore.emit(CHANGE_EVENT);
            break;

          case ApplicationConstants.SIDE_DRAWER_OPEN:
            _store.drawerOpen = true;
            ApplicationStore.emit(CHANGE_EVENT);
            break;

          case ApplicationConstants.SIDE_DRAWER_CLOSE:
            _store.drawerOpen = false;
            ApplicationStore.emit(CHANGE_EVENT);
            break;

          default:
            return true;
        }
      });
    }
  }, {
    key: "getList",
    value: function getList() {
      return Map(_store).toObject();
    }
  }, {
    key: "theme",
    get: function get() {
      return _store.theme;
    }
  }]);

  return ApplicationStoreClass;
}(StoreClass);

var ApplicationStore = new ApplicationStoreClass();
export default ApplicationStore;